
import NewsLetter from '../section/newsletterpage/NewsLetter.jsx'
export default function NewsLetterPage() {
  return (
    <div className="h-full">
        <NewsLetter/>
    </div>
  )
}